import { useEffect } from 'react'

export const useUpdateContent = (
  scriptLoaded: boolean,
  geo: string,
  mode: string
) => {
  useEffect(() => {
    if (scriptLoaded) {
      window.updateContent?.()
    }
  }, [geo, mode, scriptLoaded])
}